import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f2f273ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f2f273ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f273ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f273ee')) {
      api.createRecord('f2f273ee', component.options)
    } else {
      api.reload('f2f273ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f2f273ee&scoped=true", function () {
      api.rerender('f2f273ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/studentMessageCenter/index.vue"
export default component.exports